import _ from 'lodash';

export class StateUtils {
  public static actionType(moduleName: string) {

    return ([ type ]: TemplateStringsArray) => {
      return `[${_.capitalize(moduleName)}] ${_.snakeCase(type)}`;
    };
  }
}
